import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import {
  Search,
  ShoppingBag,
  LogOut,
  LogIn,
  UserPlus,
  Package,
  Menu,
  X,
} from "lucide-react";
import "./Header.css";

export default function Header() {
  const navigate = useNavigate();
  const { cartCount } = useCart();
  const { isAuthenticated, logout } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSearch = e => {
    e.preventDefault();
    if (searchTerm.trim()) navigate(`/?search=${encodeURIComponent(searchTerm)}`);
    setMobileOpen(false);
  };

  const confirmLogout = () => {
    setMobileOpen(false);
    logout();
    setShowLogoutConfirm(false);
    navigate("/");
  };

  function closeMobile() {
    setMobileOpen(false);
  }

  return (
    <>
      <header className="site-header">
        <div className="header-inner">
          {/* LOGO */}
          <div
            className="logo"
            onClick={() => {
              navigate("/");
              closeMobile();
            }}>
            <span className="logo-main">TAKO</span>
            
          </div>

          {/* SEARCH: always visible */}
          <form className="search-bar"
            onSubmit={handleSearch}
            role="search"
            style={{ flex: '1 1 0px', minWidth: 0, maxWidth: 480, margin: "0 12px" }}>
            <Search size={18} className="search-icon" />
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              aria-label="Search products"
            />
          </form>

          {/* CART always visible */}
          <div
            className="cart-trigger"
            onClick={() => {
              navigate("/cart");
              closeMobile();
            }}
            tabIndex={0}
            aria-label="Shopping cart"
            role="button">
            <ShoppingBag size={21} />
            {cartCount > 0 && <span className="cart-dot">{cartCount}</span>}
          </div>

          {/* TOGGLE BUTTON always right, only on mobile */}
          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileOpen(val => !val)}
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileOpen}
          >
            {mobileOpen ? <X size={28} /> : <Menu size={26} />}
          </button>

          {/* DESKTOP ACTIONS */}
          <nav className="header-actions desktop-only" aria-label="header actions">
            {!isAuthenticated ? (
              <>
                <button className="header-btn" onClick={() => navigate("/login")}>
                  <LogIn size={18} />Login
                </button>
                <button className="header-btn " onClick={() => navigate("/register")}>
                  <UserPlus size={18} />Signup
                </button>
              </>
            ) : (
              <>
                <button className="header-btn" onClick={() => navigate("/orders")}>
                  <Package size={18} />Orders
                </button>
                <button className="header-btn logout" onClick={() => setShowLogoutConfirm(true)}>
                  <LogOut size={18} />Logout
                </button>
              </>
            )}
          </nav>
        </div>

        {/* SLIDE-OVER MOBILE MENU */}
        <div className={`header-actions-mob ${mobileOpen ? "open" : ""}`}>
          <button
            className="close-mob-menu"
            onClick={closeMobile}
            aria-label="Close menu"
            tabIndex={0}
          >
            <X size={30} />
          </button>
          {!isAuthenticated ? (
            <>
              <button
                className="header-btn"
                onClick={() => {
                  navigate("/login");
                  closeMobile();
                }}>
                <LogIn size={18} />Login
              </button>
              <button
                className="header-btn primary"
                onClick={() => {
                  navigate("/register");
                  closeMobile();
                }}>
                <UserPlus size={18} />Signup
              </button>
            </>
          ) : (
            <>
              <button
                className="header-btn"
                onClick={() => {
                  navigate("/orders");
                  closeMobile();
                }}>
                <Package size={18} />Orders
              </button>
              <button
                className="header-btn logout"
                onClick={() => {
                  setShowLogoutConfirm(true);
                  closeMobile();
                }}>
                <LogOut size={18} />Logout
              </button>
            </>
          )}
        </div>
      </header>

      {/* LOGOUT MODAL */}
      {showLogoutConfirm && (
        <div className="logout-modal-overlay">
          <div className="logout-modal">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to logout?</p>
            <div className="logout-actions">
              <button onClick={() => setShowLogoutConfirm(false)} className="cancel-btn">
                No
              </button>
              <button onClick={confirmLogout} className="confirm-btn">
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}